const get = require('lodash/get');
const isEmpty = require('lodash/isEmpty');

require('core-js/fn/array/from');
require('core-js/fn/array/find');

const constants = Object.freeze({
	ACTIVE_CATEGORY_CLASS: 'active-cat',
});

const searchFacets = {
	constants,
	_eventHandlersInitialized: false,
	_featureFlagCache: null,
};

searchFacets.initialize = function() {
	try {
		sessionStorage.removeItem('facetExpandedStates');
	} catch (e) {
		// Silently handle storage errors
	}
};

searchFacets.initialize();

searchFacets.clearAllFilters = function () {
	searchFacets.clearFacetCheckboxes(true);
	searchFacets.clearSelectedCategory();
	searchFacets.handleFacetChange(true);
};

searchFacets.getFacetsModule = function () {
	return rp$('.search-facets-module');
};

searchFacets.handleFacetChange = function (useMobileFacets, category = '', identifierName = '', isChecked = false, use_cfc = false) {

	const $facetsModule = searchFacets.getFacetsModule();
	const categoryFacetTypes = JSON.parse($facetsModule.attr('data-category-facet-types') || '[]');
	const isCategoryFacet = (name) => categoryFacetTypes.includes(name);

	if (isCategoryFacet(identifierName)) {
		searchFacets.handleCategoryFacetsSelection(category);
	}

	const { facetValues } = searchFacets.getFacetValuesFromDom(useMobileFacets);
	if (!facetValues[identifierName]) {
		if (!isChecked) {
			identifierName = '';
		}
	}

	// Append search str. Append DSEO params if necessary
	const pageId = $facetsModule.data('page-id');
	const pageUrl = $facetsModule.data('page-url');
	const searchStr = $facetsModule.data('search-str');
	if (pageId) { facetValues.page_id = pageId; }
	if (pageUrl) { facetValues.page_url = pageUrl; }
	if (category) { facetValues.category = category; }
	const requestParams = {
		...facetValues,
		search_str: searchStr,
		identifier: {
			identifier: identifierName,
			usePreviousFacets: false
		},
		use_cfc: use_cfc,
	};

	$facetsModule.trigger('selectedFacetBucketsChanged', [requestParams]);
	searchFacets.disableFacets();

};

searchFacets.handleCategoryFacetsSelection = function (category) {
	let categoryCheckbox = rp$(`#${category}`);
	let subFacetsGroup = categoryCheckbox.next().next().next();
	let subFacets = subFacetsGroup.find('input[type=checkbox]');

	// Use the same logic for both desktop and mobile
	//handle Select/deselect all category's subfacets
	subFacets.each((idx, checkbox) => {
		checkbox.checked = categoryCheckbox[0] ? categoryCheckbox[0].checked : false;
	});

	// handle subfacet selection
	if (subFacets.length === 0) {
		if (categoryCheckbox.prop('checked')) {
			const parentFacetSelected = categoryCheckbox.parent().parent().prev().prev().prev();
			parentFacetSelected.attr('checked', true);
		}
	}
};

searchFacets.handleCategoryFacetClick = function (event) {
	event.preventDefault();
	const el = event.target;
	if (!el.classList.contains(constants.ACTIVE_CATEGORY_CLASS)) {
		const facetCategories = searchFacets.getFacetCategories();
		facetCategories.forEach((categoryLink) => categoryLink.classList.remove(constants.ACTIVE_CATEGORY_CLASS));

		el.classList.add(constants.ACTIVE_CATEGORY_CLASS);
		const category_selected = el.href.split('/').pop();

		// The mobile facets shouldn't trigger this on change/click, only when the 'Apply' button is clicked
		if (!el.classList.contains('mobile')) {
			searchFacets.handleFacetChange(false, category_selected);
		}
	}
};

searchFacets.showMoreFacets = function (element) {
	const keyWord = element.id.replace(/see-more-(mobile|desktop)-/, '');
	document.querySelectorAll('.hidden-filter-' + keyWord).forEach(function (el) {
		el.removeAttribute('hidden');
	});

	document.querySelectorAll(`#see-less-mobile-${keyWord}, #see-less-desktop-${keyWord}`).forEach(function (el) {
		el.removeAttribute('hidden');
		const parentLi = el.closest('li');
		if (parentLi) {
			parentLi.removeAttribute('hidden');
		}
	});
	element.setAttribute('hidden',true);
	const parentLi = element.closest('li');
	if (parentLi) {
		parentLi.setAttribute('hidden', true);
	}

	searchFacets.saveExpandedState(keyWord, true);
};

searchFacets.showLessFacets = function (element){
	const keyWord = element.id.replace(/see-less-(mobile|desktop)-/, '');
	document.querySelectorAll('.hidden-filter-' + keyWord).forEach(function(el) {
		el.setAttribute('hidden', true);
	});

	document.querySelectorAll(`#see-more-mobile-${keyWord}, #see-more-desktop-${keyWord}`).forEach(function (el) {
		el.removeAttribute('hidden');
	});
	element.setAttribute('hidden', true);

	searchFacets.saveExpandedState(keyWord, false);
};

searchFacets.showLessFacets = function (element) {
	const keyWord = element.id.replace(/see-less-(mobile|desktop)-/, '');
	document.querySelectorAll('.hidden-filter-' + keyWord).forEach(function (el) {
		el.setAttribute('hidden', true);
	});

	document.querySelectorAll(`#see-more-mobile-${keyWord}, #see-more-desktop-${keyWord}`).forEach(function (el) {
		el.removeAttribute('hidden');
		const parentLi = el.closest('li');
		if (parentLi) {
			parentLi.removeAttribute('hidden');
		}
	});
	element.setAttribute('hidden', true);
	const parentLi = element.closest('li');
	if (parentLi) {
		parentLi.setAttribute('hidden', true);
	}
};

searchFacets.preserveExpandedStates = function () {
	const expandedStates = {};

	const seeMoreButtons = document.querySelectorAll('.show-more');
	seeMoreButtons.forEach(button => {
		if (button.hasAttribute('hidden')) {
			const facetName = button.id.replace(/see-more-(mobile|desktop)-/, '');
			expandedStates[facetName] = true;
		}
	});

	return expandedStates;
};

searchFacets.restoreExpandedStates = function (expandedStates) {
	Object.keys(expandedStates).forEach(facetName => {
		if (expandedStates[facetName]) {
			const seeMoreButton = document.querySelector(`#see-more-mobile-${facetName}, #see-more-desktop-${facetName}`);
			if (seeMoreButton && !seeMoreButton.hasAttribute('hidden')) {
				searchFacets.showMoreFacets(seeMoreButton);
			}
		}
	});
};

searchFacets.getFacetCheckboxes = function () {
	return Array.from(
		document.querySelectorAll('.search-facets-module .multi-select-facet-checkbox.desktop')
	);
};

searchFacets.getMobileFacetCheckboxes = function () {
	return Array.from(
		document.querySelectorAll('.search-facets-module .multi-select-facet-checkbox.mobile')
	);
};

searchFacets.getFacetCategories = function () {
	return Array.from(
		document.querySelectorAll('.customer-friendly-categories .card.cfc .subcategories-list .subcategory')
	);
};

searchFacets.handleParentCategoryExpand = function () {
	const expandCategoryArrows = rp$('.nested-facet-arrow');

	if (!expandCategoryArrows) return;

	expandCategoryArrows.each((_, arrow) => {
		const target = arrow.getAttribute('data-target');

		arrow.removeEventListener('click', arrow._expandHandler);

		arrow._expandHandler = (e) => {
			e.stopPropagation();
			e.preventDefault();

			const subCategorySection = rp$(`[data-url-name="${target}"]`);
			if (subCategorySection) {
				subCategorySection.each((_, section) => {
					section.toggleAttribute('hidden');
				});
			}

			arrow.classList.toggle('expanded');
		};

		arrow.addEventListener('click', arrow._expandHandler);
	});
};

searchFacets.prepareFacets = function () {

	const facetsModule = searchFacets.getFacetsModule();
	const multiSelectFacetCheckboxes = searchFacets.getFacetCheckboxes();
	const multiSelectFacetMobileCheckboxes = searchFacets.getMobileFacetCheckboxes();
	searchFacets.handleCategoryCheckBoxIcon();

	const isFeatureFlagEnabled = searchFacets.isVPageFeatureFlagEnabled();

	if (isFeatureFlagEnabled) {
		const searchListingModule = document.querySelector('.search-listing-module');
		if (searchListingModule && !searchListingModule.classList.contains('search-based-v-page')) {
			searchListingModule.classList.add('search-based-v-page');
		}

		const searchFiltersModule = document.querySelector('.search-filters-module');
		if (searchFiltersModule && !searchFiltersModule.classList.contains('search-based-v-page')) {
			searchFiltersModule.classList.add('search-based-v-page');
		}

		const desktopSearchFilters = document.querySelector('.desktop-search-filters');
		if (desktopSearchFilters && !desktopSearchFilters.classList.contains('search-based-v-page')) {
			desktopSearchFilters.classList.add('search-based-v-page');
		}

		const filtersOverlay = document.querySelector('#filters-overlay, .filters-overlay');
		if (filtersOverlay && !filtersOverlay.classList.contains('search-based-v-page')) {
			filtersOverlay.classList.add('search-based-v-page');
		}

		const searchFacetsModules = document.querySelectorAll('.search-facets-module');
		searchFacetsModules.forEach(module => {
			if (!module.classList.contains('search-based-v-page')) {
				module.classList.add('search-based-v-page');
			}
		});

		const searchContainer = document.querySelector('.search-container, .search-page, .products-page, .main-content');
		if (searchContainer && !searchContainer.classList.contains('search-based-v-page')) {
			searchContainer.classList.add('search-based-v-page');
		}

		searchFacets.initializeCollapsibleFacets();

		searchFacets.updateAppliedFiltersPills();

		searchFacets.initializeClearAllButton();
		searchFacets.initializePillsScroll();

		// Only register global event handlers once to prevent multiple registrations
		if (!searchFacets._eventHandlersInitialized) {
			searchFacets.initializeVehicleChangeListener();

			searchFacets.initializeAppliedFilters();

			const vehiclePickers = document.querySelectorAll('.refine-results select, .vehicle-picker select, select[name*="make"], select[name*="model"], select[name*="year"]');
			vehiclePickers.forEach(select => {
				select.removeEventListener('change', select._vehicleChangeHandler);
				select._vehicleChangeHandler = () => {
					setTimeout(() => {
						searchFacets.updateAppliedFiltersPills();
					}, 100);
				};
				select.addEventListener('change', select._vehicleChangeHandler);
			});

			rp$(document).on('searchResults:response', (e, response = {}) => {
				const facetsData = response.facets || response.filters;
				if (response && facetsData) {
					searchFacets.updateSelectedFacetCheckboxes(facetsData);
					searchFacets.enableFacets();

					setTimeout(() => {
						searchFacets.prepareFacets();
					}, 50);
				}
			});

			rp$(document).on('searchResults:request', () => {
				searchFacets.updateAppliedFiltersPills();
			});

			rp$(document).ready(() => {
				const searchListingModuleReady = document.querySelector('.search-listing-module');
				if (searchListingModuleReady) {
					setTimeout(() => {
						searchFacets.updateAppliedFiltersPills();
					}, 200);
				}
			});

			window.updateAppliedFiltersTitle = function () {
				searchFacets.updateAppliedFiltersPills();
			};

			const titleObserver = new MutationObserver((mutations) => {
				mutations.forEach((mutation) => {
					if (mutation.type === 'childList' || mutation.type === 'characterData') {
						const target = mutation.target;
						if (target.textContent && target.textContent.includes('+')) {
							target.textContent = target.textContent.replace(/\+/g, ' ');
						}
					}
				});
			});

			const titleElements = document.querySelectorAll('h1, h2, h3, .page-title, .results-title, #applied-filters-title');
			titleElements.forEach(element => {
				titleObserver.observe(element, {
					childList: true,
					characterData: true,
					subtree: true
				});
			});

			searchFacets._eventHandlersInitialized = true;
		}
	}

	const mobileFiltersApplyButton = rp$('#mobile-filters-apply-button');
	const mobileFiltersClearButton = rp$('#mobile-filters-clear-button');

	if (facetsModule) {

		const showMore = Array.from(
			document.querySelectorAll('.show-more')
		);
		showMore.forEach((showMoreButton) => {
			showMoreButton.addEventListener('click', () => searchFacets.showMoreFacets(showMoreButton));
		});

		const showLess = Array.from(
			document.querySelectorAll('.show-less')
		);

		showLess.forEach((showLessButton) => {
			showLessButton.addEventListener('click', () => searchFacets.showLessFacets(showLessButton));
		});

		multiSelectFacetCheckboxes.forEach((checkbox) => {
			checkbox.removeEventListener('change', checkbox._facetChangeHandler);

			checkbox._facetChangeHandler = () => {
				searchFacets.handleFacetChange(false, checkbox.getAttribute('id'), checkbox.getAttribute('data-query-name'), checkbox.checked);
			};

			checkbox.addEventListener('change', checkbox._facetChangeHandler);
		});

		multiSelectFacetMobileCheckboxes.forEach((checkbox) => {
			checkbox.removeEventListener('change', checkbox._facetChangeHandler);

			checkbox._facetChangeHandler = () => {
				searchFacets.handleFacetChange(true, checkbox.getAttribute('id'), checkbox.getAttribute('data-query-name'), checkbox.checked);
			};

			checkbox.addEventListener('change', checkbox._facetChangeHandler);
		});

		if (mobileFiltersApplyButton && mobileFiltersApplyButton.length) {
			rp$('#mobile-filters-apply-button').on('click', () => {
				multiSelectFacetMobileCheckboxes.forEach((checkbox) => {
					if (checkbox.checked) {
						searchFacets.handleFacetChange(true, checkbox.getAttribute('id'), checkbox.getAttribute('data-query-name'), checkbox.checked);
					}
				});
			});
		}

		if (mobileFiltersClearButton && mobileFiltersClearButton.length) {
			rp$('#mobile-filters-clear-button').on('click', () => { searchFacets.clearAllFilters(); });
		}
	}

	searchFacets.handleParentCategoryExpand();

	searchFacets.restoreExpandedStates();
};

searchFacets.getFacetValuesFromDom = function (useMobileFacets = false, showCategoryIfAllSubcategoriesSelected = false) {
	const multiSelectFacetCheckboxes = useMobileFacets ? searchFacets.getMobileFacetCheckboxes() : searchFacets.getFacetCheckboxes();
	const $facetsModule = searchFacets.getFacetsModule();
	const categoryFacetTypes = JSON.parse($facetsModule.attr('data-category-facet-types') || '[]');
	const isCategoryFacet = (name) => categoryFacetTypes.includes(name);

	const facetValues = {};
	multiSelectFacetCheckboxes.forEach(checkbox => {
		if (checkbox.checked) {
			const queryName = checkbox.getAttribute('data-query-name');
			const checkboxName = checkbox.getAttribute('name');
			const urlName = checkbox.getAttribute('data-url-name');

			const valueToUse = urlName || checkboxName;

			const isSubFacet = checkboxName.includes('%3E') || checkbox.closest('.sub-facet-group');
			const isCategory = isCategoryFacet(queryName);
			let allSubcategoriesSelected = false;
			let allSiblingsSelected = false;
			
			if (!isSubFacet && isCategory) {
				allSubcategoriesSelected = true;

				rp$(checkbox)
					.closest('li')
					.find('.sub-facet-group > li > input.multi-select-facet-checkbox')
					.each((idx, subFacet) => {
						if (!subFacet.checked) {
							allSubcategoriesSelected = false;
						}
					});
			} else if (isSubFacet) {
				allSiblingsSelected = true;

				rp$(checkbox).closest('.sub-facet-group').find('li >input.multi-select-facet-checkbox').each((idx, subFacet) => {
					if (!subFacet.checked) {
						allSiblingsSelected = false;
					}
				});
			}

			if (showCategoryIfAllSubcategoriesSelected && allSubcategoriesSelected) {
				if (!facetValues[queryName]) {
					facetValues[queryName] = [];
				}
				facetValues[queryName].push(valueToUse);
			} else if ((isSubFacet || !isCategoryFacet(queryName)) && (!showCategoryIfAllSubcategoriesSelected || !allSiblingsSelected)) {
				if (!facetValues[queryName]) {
					facetValues[queryName] = [];
				}
				facetValues[queryName].push(valueToUse);
			}
		}
	});

	const facetCategories = searchFacets.getFacetCategories();
	const activeCategoryLink = facetCategories.find(
		(categoryLink) => categoryLink.classList.contains(constants.ACTIVE_CATEGORY_CLASS)
	);
	if (activeCategoryLink) {
		const $parentFacetWrapper = rp$(activeCategoryLink).closest('.facet-wrapper');
		if ($parentFacetWrapper.length === 1) {
			const categoryQueryName = $parentFacetWrapper.attr('data-query-name');
			if (categoryQueryName) {
				facetValues[categoryQueryName] = activeCategoryLink.getAttribute('data-cfc-node-id');
			}
		}
	}
	return { facetValues };
};

searchFacets.getAvailableSearchFacetQueryNames = function () {
	const facets = Array.from(
		document.querySelectorAll('.search-facets-module .facet-wrapper')
	);

	return facets.map((facet) => facet.getAttribute('data-query-name'));
};

searchFacets.updateSelectedFacetCheckboxes = function (selectedFacetData) {
	const selectedFacets = isEmpty(selectedFacetData) ? {} : selectedFacetData;
	const checkboxes = searchFacets.getFacetCheckboxes();

	checkboxes.forEach((checkbox) => {
		const checkboxName = checkbox.getAttribute('name');
		const checkboxQueryName = checkbox.getAttribute('data-query-name');
		const buckets = get(selectedFacets, `[${checkboxQueryName}]`, []);
		const checked = buckets.includes(checkboxName);
		checkbox.checked = checked;
	});
};

searchFacets.clearFacetCheckboxes = function (useMobileFacets = false) {
	const checkboxes = useMobileFacets
		? searchFacets.getMobileFacetCheckboxes()
		: searchFacets.getFacetCheckboxes();

	if (checkboxes && checkboxes.length) {
		checkboxes.forEach((checkbox) => {
			checkbox.checked = false;
		});
	}
};

searchFacets.clearSelectedCategory = function () {
	const facetCategories = searchFacets.getFacetCategories();
	const activeCategoryLink = facetCategories.find(
		(categoryLink) => categoryLink.classList.contains(constants.ACTIVE_CATEGORY_CLASS)
	);

	if (activeCategoryLink) {
		activeCategoryLink.classList.remove(constants.ACTIVE_CATEGORY_CLASS);
	}
};

searchFacets.handleCategoryCheckBoxIcon = function () {
	const arrowButtons = rp$('.search-facets-module .nested-facet-arrow');
	arrowButtons.each((idx, arrowButton) => {
		const arrow = rp$(arrowButton);

		const subFacetsGroup = arrow.next().find('input[type=checkbox]');
		const selectedSubFacets = subFacetsGroup.filter((idx, subFacet) => subFacet.checked);
		const label = arrow.prev();
		const inputCheckbox = label.prev();
		if (selectedSubFacets.length > 0) {
			inputCheckbox.attr('checked', true);
		}

		if (selectedSubFacets.length < subFacetsGroup.length) {
			if (inputCheckbox.prop('checked')) {
				label.addClass('partial');
			}
			if (selectedSubFacets.length === 0) {
				inputCheckbox.attr('checked', false);
				label.removeClass('partial');
			}
		}
	});
};

function setFacetsInteractiveState(enabled) {
	const checkboxes = searchFacets.getFacetCheckboxes();
	checkboxes.forEach((checkbox) => {
		checkbox.disabled = !enabled;
	});

	const categoryFacetWrapper = document.querySelector('.facet-wrapper.categories-facet');
	if (categoryFacetWrapper) {
		if (enabled) {
			categoryFacetWrapper.classList.remove('disabled');
		} else {
			categoryFacetWrapper.classList.add('disabled');
		}
	}
}

searchFacets.disableFacets = function () { setFacetsInteractiveState(false); };
searchFacets.enableFacets = function () { setFacetsInteractiveState(true); };

searchFacets.initializeCollapsibleFacets = function () {
	if (!searchFacets.isVPageFeatureFlagEnabled()) {
		return;
	}

	// Allow custom sites to opt-out of default accordion behavior
	// by adding data-disable-default-accordion="true" to .search-facets-module
	const facetsModule = document.querySelector('.search-facets-module');
	if (facetsModule && facetsModule.getAttribute('data-disable-default-accordion') === 'true') {
		return;
	}

	const collapsibleFacets = document.querySelectorAll('.collapsible-facet');

	collapsibleFacets.forEach((facet) => {
		const header = facet.querySelector('.facet-header');
		const toggleBtn = facet.querySelector('.facet-toggle-btn');
		const content = facet.querySelector('.facet-content');

		if (header && toggleBtn && content) {
			const hasSelectedItems = content.querySelectorAll('input[type="checkbox"]:checked').length > 0;

			if (hasSelectedItems || facet.getAttribute('data-default-expanded') === 'true') {
				facet.setAttribute('data-collapsed', 'false');
				content.hidden = false;
				toggleBtn.classList.add('expanded');
			} else {
				facet.setAttribute('data-collapsed', 'true');
				content.hidden = true;
				toggleBtn.classList.remove('expanded');
			}

			if (header._toggleHandler) {
				header.removeEventListener('click', header._toggleHandler);
			}

			header._toggleHandler = (e) => {
				if (e.target.type === 'checkbox' || e.target.tagName === 'LABEL') {
					return;
				}

				const isCollapsed = facet.getAttribute('data-collapsed') === 'true';

				if (isCollapsed) {
					// Expand
					facet.setAttribute('data-collapsed', 'false');
					content.hidden = false;
					toggleBtn.classList.add('expanded');
				} else {
					// Collapse
					facet.setAttribute('data-collapsed', 'true');
					content.hidden = true;
					toggleBtn.classList.remove('expanded');
				}
			};

			header.addEventListener('click', header._toggleHandler);

			const checkboxes = content.querySelectorAll('input[type="checkbox"]');
			checkboxes.forEach(checkbox => {
				if (checkbox._clickStopHandler) {
					checkbox.removeEventListener('click', checkbox._clickStopHandler);
				}
				checkbox._clickStopHandler = (e) => {
					e.stopPropagation();
				};
				checkbox.addEventListener('click', checkbox._clickStopHandler);
			});
		}
	});
};

searchFacets.initializeVehicleChangeListener = function () {
	document.addEventListener('vehicleSelected', (event) => {
		const vehicleData = event.detail;
		searchFacets.refreshFacetsForVehicle(vehicleData);
	});

	const vehicleSelectors = document.querySelectorAll('select[name*="year"], select[name*="make"], select[name*="model"]');
	vehicleSelectors.forEach(selector => {
		selector.addEventListener('change', () => {
			const form = selector.closest('form');
			if (form) {
				const formData = new FormData(form);
				const vehicleData = {
					year: formData.get('year'),
					make: formData.get('make'),
					model: formData.get('model'),
					trim: formData.get('trim'),
					engine: formData.get('engine')
				};
				searchFacets.refreshFacetsForVehicle(vehicleData);
			}
		});
	});
};

searchFacets.refreshFacetsForVehicle = function (vehicleData) {
	searchFacets.showFacetsLoading();

	fetch('/ajax/search/refresh-facets', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(vehicleData)
	}).then(response => response.json())
		.then(data => {
			if (data.success) {
				searchFacets.updateFacetsDisplay(data.facets);
			}
		}).catch(() => {
			// Silently handle fetch errors - facets will remain in current state
		})
		.finally(() => {
			searchFacets.hideFacetsLoading();
		});
};

searchFacets.showFacetsLoading = function () {
	const facetsModule = document.querySelector('.search-facets-module');
	if (facetsModule) {
		facetsModule.classList.add('facets-loading');
	}
};

searchFacets.hideFacetsLoading = function () {
	const facetsModule = document.querySelector('.search-facets-module');
	if (facetsModule) {
		facetsModule.classList.remove('facets-loading');
	}
};

searchFacets.updateFacetsDisplay = function (facetsData) {
	const facetsModule = document.querySelector('.search-facets-module');
	if (!facetsModule) return;

	// Preserve the expanded state of "see more" buttons before clearing
	const expandedStates = searchFacets.preserveExpandedStates();

	const existingFacets = facetsModule.querySelectorAll('.collapsible-facet');
	existingFacets.forEach(facet => facet.remove());

	Object.keys(facetsData).forEach(facetName => {
		const facetData = facetsData[facetName];
		const facetElement = searchFacets.createFacetElement(facetName, facetData);
		facetsModule.appendChild(facetElement);
	});

	searchFacets.restoreExpandedStates(expandedStates);

	searchFacets.initializeCollapsibleFacets();

	searchFacets.prepareFacets();
};

searchFacets.createFacetElement = function (facetName, facetData) {
	const facetElement = document.createElement('div');
	facetElement.className = 'facet-wrapper multi-select-facet collapsible-facet';
	facetElement.setAttribute('data-facet-name', facetName);
	facetElement.setAttribute('data-query-name', facetName.toLowerCase().replace(/\s+/g, '_'));
	facetElement.setAttribute('data-collapsed', 'true');

	const header = document.createElement('div');
	header.className = 'facet-header';

	const title = document.createElement('span');
	title.className = 'facet-title';
	title.textContent = facetName;

	const toggleBtn = document.createElement('button');
	toggleBtn.type = 'button';
	toggleBtn.className = 'facet-toggle-btn';
	toggleBtn.setAttribute('aria-label', `Toggle ${facetName} facet`);

	header.appendChild(title);
	header.appendChild(toggleBtn);

	const content = document.createElement('ul');
	content.className = 'facet-content';
	content.hidden = true;

	if (facetData.buckets && facetData.buckets.length > 0) {
		facetData.buckets.forEach((bucket) => {
			const li = document.createElement('li');

			const checkbox = document.createElement('input');
			checkbox.type = 'checkbox';
			checkbox.id = `desktop_${bucket.id}`;
			checkbox.name = bucket.ui_name;
			checkbox.className = 'multi-select-facet-checkbox desktop';
			checkbox.setAttribute('data-url-name', bucket.url_name);
			checkbox.setAttribute('data-query-name', facetName.toLowerCase().replace(/\s+/g, '_'));
			if (bucket.is_checked) {
				checkbox.checked = true;
			}

			const label = document.createElement('label');
			label.setAttribute('for', `desktop_${bucket.id}`);
			label.textContent = bucket.label;

			li.appendChild(checkbox);
			li.appendChild(label);
			content.appendChild(li);
		});
	}

	facetElement.appendChild(header);
	facetElement.appendChild(content);

	return facetElement;
};

searchFacets.initializeAppliedFilters = function () {
	searchFacets.updateAppliedFiltersPills();


	setTimeout(() => {
		searchFacets.updateAppliedFiltersPills();
	}, 100);
};

searchFacets.initializeClearAllButton = function () {
	const searchListingModule = document.querySelector('.search-listing-module');
	if (!searchListingModule) return;

	const clearAllBtn = searchListingModule.querySelector('.clear-all-filters-btn');
	if (clearAllBtn) {
		if (clearAllBtn._clearAllHandler) {
			clearAllBtn.removeEventListener('click', clearAllBtn._clearAllHandler);
		}

		clearAllBtn._clearAllHandler = () => {
			searchFacets.clearAllFilters();
		};

		clearAllBtn.addEventListener('click', clearAllBtn._clearAllHandler);
	}
};

searchFacets.initializePillsScroll = function () {
	const searchListingModule = document.querySelector('.search-listing-module');
	if (!searchListingModule) return;

	const scrollButtons = searchListingModule.querySelectorAll('.pills-scroll-btn');

	scrollButtons.forEach(btn => {
		if (btn._scrollHandler) {
			btn.removeEventListener('click', btn._scrollHandler);
		}

		btn._scrollHandler = () => {
			const target = btn.getAttribute('data-target');
			const isLeft = btn.classList.contains('scroll-left');
			const pillsContainer = searchListingModule.querySelector(`#applied-filters-pills-${target}`);

			if (pillsContainer) {
				const scrollAmount = 200; // Scroll 200px at a time
				if (isLeft) {
					pillsContainer.scrollLeft -= scrollAmount;
				} else {
					pillsContainer.scrollLeft += scrollAmount;
				}

				setTimeout(() => {
					searchFacets.updatePillsScrollButtons(pillsContainer, target);
				}, 300);
			}
		};

		btn.addEventListener('click', btn._scrollHandler);
	});

	const pillsContainers = searchListingModule.querySelectorAll('.applied-filters-pills');
	pillsContainers.forEach(container => {
		const target = container.id.includes('mobile') ? 'mobile' : 'desktop';

		if (container._scrollHandler) {
			container.removeEventListener('scroll', container._scrollHandler);
		}

		container._scrollHandler = () => {
			searchFacets.updatePillsScrollButtons(container, target);
		};

		container.addEventListener('scroll', container._scrollHandler);

		searchFacets.updatePillsScrollButtons(container, target);
	});

	if (!window._pillsScrollResizeHandlerAttached) {
		window._pillsScrollResizeHandler = () => {
			const searchListingMod = document.querySelector('.search-listing-module');
			if (!searchListingMod) return;

			const containers = searchListingMod.querySelectorAll('.applied-filters-pills');
			containers.forEach(container => {
				const target = container.id.includes('mobile') ? 'mobile' : 'desktop';
				searchFacets.updatePillsScrollButtons(container, target);
			});
		};
		window.addEventListener('resize', window._pillsScrollResizeHandler);
		window._pillsScrollResizeHandlerAttached = true;
	}
};

searchFacets.updatePillsScrollButtons = function (pillsContainer, target) {
	const searchListingModule = document.querySelector('.search-listing-module');
	if (!searchListingModule) return;

	const leftBtn = searchListingModule.querySelector(`.pills-scroll-btn.scroll-left.${target}-only`);
	const rightBtn = searchListingModule.querySelector(`.pills-scroll-btn.scroll-right.${target}-only`);

	if (!leftBtn || !rightBtn) return;

	const isAtStart = pillsContainer.scrollLeft <= 0;
	const isAtEnd = pillsContainer.scrollLeft >= pillsContainer.scrollWidth - pillsContainer.clientWidth - 1;
	const canScroll = pillsContainer.scrollWidth > pillsContainer.clientWidth;

	// hide the buttons if there's nothing to scroll
	leftBtn.style.display = rightBtn.style.display = canScroll ? 'flex' : 'none';

	if (canScroll) {
		leftBtn.disabled = isAtStart;
		rightBtn.disabled = isAtEnd;
	}
};

searchFacets.getVehicleInformation = function () {
	let vehicleInfo = {};
	
	//  Check URL path first (most reliable for vehicle-specific pages)
	const pathMatch = window.location.pathname.match(/\/v\/(\d{4})\/([^/]+)\/([^/]+)/);
	if (pathMatch) {
		vehicleInfo.year = pathMatch[1];
		vehicleInfo.make = decodeURIComponent(pathMatch[2]).replace(/\+/g, ' ');
		vehicleInfo.model = decodeURIComponent(pathMatch[3]).replace(/\+/g, ' ');
		return vehicleInfo;
	}
	
	// Check for DSEO-specific URL patterns
	const dseoPathMatch = window.location.pathname.match(/\/(\d{4})-([^/]+)-([^/]+)/);
	if (dseoPathMatch) {
		vehicleInfo.year = dseoPathMatch[1];
		vehicleInfo.make = decodeURIComponent(dseoPathMatch[2]).replace(/\+/g, ' ');
		vehicleInfo.model = decodeURIComponent(dseoPathMatch[3]).replace(/\+/g, ' ');
		return vehicleInfo;
	}
	
	//  Check URL parameters
	const urlParams = new URLSearchParams(window.location.search);
	const urlYear = urlParams.get('year');
	const urlMake = urlParams.get('make');
	const urlModel = urlParams.get('model');
	
	if (urlYear && urlMake && urlModel) {
		vehicleInfo.year = urlYear;
		vehicleInfo.make = decodeURIComponent(urlMake).replace(/\+/g, ' ');
		vehicleInfo.model = decodeURIComponent(urlModel).replace(/\+/g, ' ');
		return vehicleInfo;
	}
	
	//  Check what's actually selected in vehicle picker dropdowns 
	// First check if we're on a normal search listing page with refine results
	const isNormalSearchListing = document.querySelector('.search-filters-module .vehicle-filter-container, .refine-results, .vehicle-picker, .filter-section');
	
	if (isNormalSearchListing) {
		let yearSelect = null;
		let makeSelect = null;
		let modelSelect = null;

		// Look for selects in refine results area first - specifically target search-filters-module
		const refineResults = document.querySelector('.search-filters-module .vehicle-filter-container, .refine-results, .vehicle-picker, .filter-section');
		if (refineResults) {
			const refineSelects = refineResults.querySelectorAll('select');
			if (refineSelects.length >= 3) {
				// Assume first is make, second is model, third is year
				makeSelect = refineSelects[0];
				modelSelect = refineSelects[1];
				yearSelect = refineSelects[2];
			} else if (refineSelects.length >= 2) {
				// Assume first is make, second is model
				makeSelect = refineSelects[0];
				modelSelect = refineSelects[1];
			}
		}

		// If not found in refine results, try to find by specific class names
		if (!makeSelect) {
			makeSelect = document.querySelector('select.refine-make-select, select[class*="make-select"]');
		}
		if (!modelSelect) {
			modelSelect = document.querySelector('select.refine-model-select, select[class*="model-select"]');
		}
		if (!yearSelect) {
			yearSelect = document.querySelector('select.refine-year-select, select[class*="year-select"]');
		}

		// Fallback to specific selectors
		if (!makeSelect) {
			makeSelect = document.querySelector('select[name*="make"], select[id*="make"], .vehicle-make select, select[data-name="make"]');
		}
		if (!modelSelect) {
			modelSelect = document.querySelector('select[name*="model"], select[id*="model"], .vehicle-model select, select[data-name="model"]');
		}
		if (!yearSelect) {
			yearSelect = document.querySelector('select[name*="year"], select[id*="year"], .vehicle-year select, select[data-name="year"]');
		}

		// Check if we have at least make and model selects
		if (makeSelect && modelSelect) {
			const selectedMake = makeSelect.value;
			const selectedModel = modelSelect.value;
			const selectedYear = yearSelect ? yearSelect.value : null;

			if (selectedMake && selectedMake !== 'all' && selectedMake !== '' && selectedMake !== 'All Makes') {
				vehicleInfo.make = selectedMake;

				if (selectedYear && selectedYear !== 'all' && selectedYear !== '' && selectedYear !== 'All Years') {
					vehicleInfo.year = selectedYear;
				}

				if (selectedModel && selectedModel !== 'all' && selectedModel !== '' && selectedModel !== 'All Models') {
					vehicleInfo.model = selectedModel;
				}

				return vehicleInfo;
			}
		}
	} // End of normal search listing page detection

	// Fallback: Check for any select elements in refine results area - specifically target search-filters-module
	const refineSelects = document.querySelectorAll('.search-filters-module .vehicle-filter-container select, .refine-results select, .vehicle-picker select, select.refine-make-select, select.refine-model-select, select.refine-year-select');
	if (refineSelects.length >= 2) {
		// Try to find the specific selects by class
		let makeSelectFallback = document.querySelector('select.refine-make-select');
		let modelSelectFallback = document.querySelector('select.refine-model-select');
		let yearSelectFallback = document.querySelector('select.refine-year-select');

		// If not found by class, use the first few selects
		if (!makeSelectFallback && refineSelects.length >= 1) {
			makeSelectFallback = refineSelects[0];
		}
		if (!modelSelectFallback && refineSelects.length >= 2) {
			modelSelectFallback = refineSelects[1];
		}
		if (!yearSelectFallback && refineSelects.length >= 3) {
			yearSelectFallback = refineSelects[2];
		}

		const selectedMakeFallback = makeSelectFallback ? makeSelectFallback.value : '';
		const selectedModelFallback = modelSelectFallback ? modelSelectFallback.value : '';
		if (selectedMakeFallback && selectedMakeFallback !== 'all' && selectedMakeFallback !== '' && selectedMakeFallback !== 'All Makes') {
			vehicleInfo.make = selectedMakeFallback;

			if (selectedModelFallback && selectedModelFallback !== 'all' && selectedModelFallback !== '' && selectedModelFallback !== 'All Models') {
				vehicleInfo.model = selectedModelFallback;
			}

			// Check for year if available
			if (yearSelectFallback) {
				const selectedYearFallback = yearSelectFallback.value;
				if (selectedYearFallback && selectedYearFallback !== 'all' && selectedYearFallback !== '' && selectedYearFallback !== 'All Years') {
					vehicleInfo.year = selectedYearFallback;
				}
			}

			return vehicleInfo;
		}
	}

	// Check vehicle picker data attributes (most reliable for DSEO pages)
	const vpGarage = document.querySelector('.vp-category-garage');
	if (vpGarage) {
		const year = vpGarage.getAttribute('data-vehicle-year');
		const make = vpGarage.getAttribute('data-vehicle-make');
		const model = vpGarage.getAttribute('data-vehicle-model');

		if (year && make && model) {
			vehicleInfo.year = year;
			vehicleInfo.make = decodeURIComponent(make).replace(/\+/g, ' ');
			vehicleInfo.model = decodeURIComponent(model).replace(/\+/g, ' ');
			return vehicleInfo;
		}
	}

	// Check vehicle picker wrapper
	const vpWrapper = document.querySelector('.vehiclepicker_wrapper');
	if (vpWrapper) {
		const year = vpWrapper.getAttribute('data-year');
		const make = vpWrapper.getAttribute('data-make');
		const model = vpWrapper.getAttribute('data-model');

		if (year && make && model) {
			vehicleInfo.year = year;
			vehicleInfo.make = decodeURIComponent(make).replace(/\+/g, ' ');
			vehicleInfo.model = decodeURIComponent(model).replace(/\+/g, ' ');
			return vehicleInfo;
		}
	}

	// Check vehicle dropdowns (FIXED - now works with partial selections)
	// First try to find dropdowns in the specific search-filters-module container
	const searchFiltersModule = document.querySelector('.search-filters-module .vehicle-filter-container');
	let yearSelectDropdown = null;
	let makeSelectDropdown = null;
	let modelSelectDropdown = null;

	if (searchFiltersModule) {
		const moduleSelects = searchFiltersModule.querySelectorAll('select');
		if (moduleSelects.length >= 3) {
			makeSelectDropdown = moduleSelects[0];
			modelSelectDropdown = moduleSelects[1];
			yearSelectDropdown = moduleSelects[2];
		} else if (moduleSelects.length >= 2) {
			makeSelectDropdown = moduleSelects[0];
			modelSelectDropdown = moduleSelects[1];
		}
	}

	// Try to find by specific class names first
	if (!makeSelectDropdown) {
		makeSelectDropdown = document.querySelector('select.refine-make-select, select[class*="make-select"]');
	}
	if (!modelSelectDropdown) {
		modelSelectDropdown = document.querySelector('select.refine-model-select, select[class*="model-select"]');
	}
	if (!yearSelectDropdown) {
		yearSelectDropdown = document.querySelector('select.refine-year-select, select[class*="year-select"]');
	}

	// Fallback to generic selectors if not found in specific container
	if (!makeSelectDropdown) {
		makeSelectDropdown = document.querySelector('select[name*="make"], select[id*="make"], .vehicle-make select');
	}
	if (!modelSelectDropdown) {
		modelSelectDropdown = document.querySelector('select[name*="model"], select[id*="model"], .vehicle-model select');
	}
	if (!yearSelectDropdown) {
		yearSelectDropdown = document.querySelector('select[name*="year"], select[id*="year"], .vehicle-year select');
	}
	// Check if we have at least a make dropdown
	if (makeSelectDropdown) {
		const makeValue = makeSelectDropdown.value;
		const makeOption = makeSelectDropdown.querySelector('option:checked');

		// Check if make is actually selected (not default placeholder)
		const isMakeSelected = makeValue && makeOption &&
			!['Make', 'Select Make', 'All Makes', 'all', ''].includes(makeOption.textContent.trim()) &&
			!['Make', 'Select Make', 'All Makes', 'all', ''].includes(makeValue);

		if (isMakeSelected) {
			vehicleInfo.make = decodeURIComponent(makeValue).replace(/\+/g, ' ');
			if (yearSelectDropdown) {
				const yearValue = yearSelectDropdown.value;
				const yearOption = yearSelectDropdown.querySelector('option:checked');
				const isYearSelected = yearValue && yearOption &&
					!['Year', 'Select Year', 'All Years', 'all', ''].includes(yearOption.textContent.trim()) &&
					!['Year', 'Select Year', 'All Years', 'all', ''].includes(yearValue);

				if (isYearSelected) {
					vehicleInfo.year = yearValue;
				}
			}
			// Check for model if available
			if (modelSelectDropdown) {
				const modelValue = modelSelectDropdown.value;
				const modelOption = modelSelectDropdown.querySelector('option:checked');
				const isModelSelected = modelValue && modelOption &&
					!['Model', 'Select Model', 'All Models', 'all', ''].includes(modelOption.textContent.trim()) &&
					!['Model', 'Select Model', 'All Models', 'all', ''].includes(modelValue);

				if (isModelSelected) {
					vehicleInfo.model = decodeURIComponent(modelValue).replace(/\+/g, ' ');
				}
			}
			return vehicleInfo;
		}
	}

	//Check search bar for vehicle text (only if it's not the default placeholder)
	const searchBar = document.querySelector('.search-bar-component input[type="text"]');
	if (searchBar && searchBar.value && searchBar.value !== 'Search All Vehicles') {
		const searchText = searchBar.value;
		const vehicleMatch = searchText.match(/(\d{4})\s+([^,\s]+)\s+([^,\s]+(?:-[^,\s]+)*)/);
		if (vehicleMatch) {
			vehicleInfo.year = vehicleMatch[1];
			vehicleInfo.make = vehicleMatch[2];
			vehicleInfo.model = vehicleMatch[3];
			return vehicleInfo;
		}
	}


	//Check for DSEO page specific elements
	const dseoElements = document.querySelectorAll('[data-vehicle-year], [data-vehicle-make], [data-vehicle-model], [data-year], [data-make], [data-model]');
	if (dseoElements.length > 0) {
		for (let element of dseoElements) {
			const year = element.getAttribute('data-vehicle-year') || element.getAttribute('data-year');
			const make = element.getAttribute('data-vehicle-make') || element.getAttribute('data-make');
			const model = element.getAttribute('data-vehicle-model') || element.getAttribute('data-model');

			if (year && make && model) {
				vehicleInfo.year = year;
				vehicleInfo.make = decodeURIComponent(make).replace(/\+/g, ' ');
				vehicleInfo.model = decodeURIComponent(model).replace(/\+/g, ' ');
				return vehicleInfo;
			}
		}
	}

	//  Check vehicle info based on page type
	// DSEO page: Look for current-vehicle with h4 element
	const currentVehicle = document.querySelector('.current-vehicle, [class*="current-vehicle"]');
	if (currentVehicle) {
		const vehicleH4 = currentVehicle.querySelector('h4');
		if (vehicleH4) {
			const vehicleText = vehicleH4.textContent || vehicleH4.innerText;
			if (vehicleText && vehicleText.match(/\d{4}\s+[A-Za-z\s]+\s+[A-Za-z0-9\s-]+/)) {
				const vehicleMatch = vehicleText.match(/(\d{4})\s+([A-Za-z\s]+)\s+([A-Za-z0-9\s-]+)/);
				if (vehicleMatch && vehicleMatch[1] && vehicleMatch[2] && vehicleMatch[3]) {
					vehicleInfo.year = vehicleMatch[1];
					vehicleInfo.make = vehicleMatch[2].trim();
					vehicleInfo.model = vehicleMatch[3].trim();
					return vehicleInfo;
				}
			}
		}
	}

	// Vehicle selection page: Look for selected-vehicle-tile with p element
	const selectedVehicleTile = document.querySelector('.selected-vehicle-tile, .vehicle-tile, .selected-vehicle, [class*="selected-vehicle"], [class*="vehicle-tile"]');
	if (selectedVehicleTile) {
		const vehicleP = selectedVehicleTile.querySelector('p');
		if (vehicleP) {
			const vehicleText = vehicleP.textContent || vehicleP.innerText;
			if (vehicleText && vehicleText.match(/\d{4}\s+[A-Za-z\s]+\s+[A-Za-z0-9\s-]+/)) {
				const vehicleMatch = vehicleText.match(/(\d{4})\s+([A-Za-z\s]+)\s+([A-Za-z0-9\s-]+)/);
				if (vehicleMatch && vehicleMatch[1] && vehicleMatch[2] && vehicleMatch[3]) {
					vehicleInfo.year = vehicleMatch[1];
					vehicleInfo.make = vehicleMatch[2].trim();
					vehicleInfo.model = vehicleMatch[3].trim();
					return vehicleInfo;
				}
			}
		}
	}

	// Look for vehicle info in main search bar input field
	const searchBarInput = document.querySelector('.search-bar-component input[type="text"], .search-input, input[placeholder*="search"], input[name*="search"], input[id*="search"]');
	if (searchBarInput) {
		const searchValue = searchBarInput.value;
		if (searchValue && searchValue.match(/\d{4}\s+[A-Za-z\s]+\s+[A-Za-z0-9\s-]+/)) {
			const vehicleMatch = searchValue.match(/(\d{4})\s+([A-Za-z\s]+)\s+([A-Za-z0-9\s-]+)/);
			if (vehicleMatch && vehicleMatch[1] && vehicleMatch[2] && vehicleMatch[3]) {
				vehicleInfo.year = vehicleMatch[1];
				vehicleInfo.make = vehicleMatch[2].trim();
				vehicleInfo.model = vehicleMatch[3].trim();
				return vehicleInfo;
			}
		}
	}

	// Look for vehicle info in search bar dropdown
	const searchBarDropdown = document.querySelector('.search-bar-component select, .vehicle-dropdown select, select[class*="vehicle"]');
	if (searchBarDropdown) {
		const searchBarValue = searchBarDropdown.value;
		if (searchBarValue && searchBarValue.match(/\d{4}\s+[A-Za-z\s]+\s+[A-Za-z0-9\s-]+/)) {
			const vehicleMatch = searchBarValue.match(/(\d{4})\s+([A-Za-z\s]+)\s+([A-Za-z0-9\s-]+)/);
			if (vehicleMatch && vehicleMatch[1] && vehicleMatch[2] && vehicleMatch[3]) {
				vehicleInfo.year = vehicleMatch[1];
				vehicleInfo.make = vehicleMatch[2].trim();
				vehicleInfo.model = vehicleMatch[3].trim();
				return vehicleInfo;
			}
		}
	}

	// Look for vehicle info in breadcrumbs
	const breadcrumbElements = document.querySelectorAll('.breadcrumb, .breadcrumbs, [class*="breadcrumb"]');
	for (let element of breadcrumbElements) {
		const text = element.textContent || element.innerText;
		if (text && text.match(/\d{4}\s+[A-Za-z\s]+\s+[A-Za-z0-9\s-]+/)) {
			const vehicleMatch = text.match(/(\d{4})\s+([A-Za-z\s]+)\s+([A-Za-z0-9\s-]+)/);
			if (vehicleMatch && vehicleMatch[1] && vehicleMatch[2] && vehicleMatch[3]) {
				vehicleInfo.year = vehicleMatch[1];
				vehicleInfo.make = vehicleMatch[2].trim();
				vehicleInfo.model = vehicleMatch[3].trim();
				return vehicleInfo;
			}
		}
	}

	const headingElements = document.querySelectorAll('h1, h2, h3, .page-title, .results-title');
	for (let element of headingElements) {
		const text = element.textContent || element.innerText;
		if (text && text.match(/\d{4}\s+[A-Za-z\s]+\s+[A-Za-z0-9\s-]+/)) {
			const vehicleMatch = text.match(/(\d{4})\s+([A-Za-z\s]+)\s+([A-Za-z0-9\s-]+)/);
			if (vehicleMatch && vehicleMatch[1] && vehicleMatch[2] && vehicleMatch[3]) {
				vehicleInfo.year = vehicleMatch[1];
				vehicleInfo.make = vehicleMatch[2].trim();
				vehicleInfo.model = vehicleMatch[3].trim();
				return vehicleInfo;
			}
		}
	}

	// If no vehicle found, return empty object
	return vehicleInfo;
};

searchFacets.getSearchString = function () {
	// Try to get search string from search facets module
	const facetsModule = searchFacets.getFacetsModule();
	if (facetsModule && facetsModule.length) {
		const searchStr = facetsModule.attr('data-search-str');
		if (searchStr) {
			return decodeURIComponent(searchStr);
		}
	}

	// If not found, try to get from URL parameters
	const urlParams = new URLSearchParams(window.location.search);
	return urlParams.get('search_str') || '';
};

searchFacets.getSelectedCategoriesCount = function () {
	const { facetValues } = searchFacets.getFacetValuesFromDom(false);

	// Count category facets (including autocareCategories and other category types)
	const categoryFacetTypes = ['category', 'categories', 'part_category', 'accessory_category', 'autocarecategories'];
	let uniqueCategories = new Set();

	Object.keys(facetValues).forEach(facetName => {
		if (categoryFacetTypes.includes(facetName.toLowerCase())) {
			const facetValuesList = facetValues[facetName];
			if (facetValuesList && Array.isArray(facetValuesList)) {
				facetValuesList.forEach(value => {
					// First replace + with spaces, then decode URI components
					let decodedValue = value.replace(/\+/g, ' ');
					// decodeURIComponent is safe - it only throws on malformed sequences
					decodedValue = decodeURIComponent(decodedValue);

					let categoryName = decodedValue;
					if (decodedValue.includes('>')) {
						categoryName = decodedValue.split('>')[0].trim();
					}

					uniqueCategories.add(categoryName);
				});
			}
		}
	});

	return uniqueCategories.size;
};

searchFacets.getSelectedCategoryName = function () {
	const { facetValues } = searchFacets.getFacetValuesFromDom(false);

	// Get the first selected category name
	const categoryFacetTypes = ['category', 'categories', 'part_category', 'accessory_category', 'autocarecategories'];

	for (const facetName of Object.keys(facetValues)) {
		if (categoryFacetTypes.includes(facetName.toLowerCase())) {
			const facetValuesList = facetValues[facetName];
			if (facetValuesList && Array.isArray(facetValuesList) && facetValuesList.length > 0) {
				let categoryName = facetValuesList[0];
				// First replace + with spaces, then decode URI components
				categoryName = categoryName.replace(/\+/g, ' ');
				// decodeURIComponent is safe - it only throws on malformed sequences
				categoryName = decodeURIComponent(categoryName);

				if (categoryName.includes('>')) {
					categoryName = categoryName.split('>')[0].trim();
				}

				return categoryName;
			}
		}
	}

	return '';
};

searchFacets.updateAppliedFiltersPills = function () {
	// Only run this function when the feature flag is enabled
	if (!searchFacets.isVPageFeatureFlagEnabled()) {
		return;
	}

	const { facetValues } = searchFacets.getFacetValuesFromDom(false, true);

	// Get applied filters containers from the search listing module
	const searchListingModule = document.querySelector('.search-listing-module');
	if (!searchListingModule) {
		return;
	}

	const mobileContainer = searchListingModule.querySelector('#applied-filters-pills-mobile');
	const desktopContainer = searchListingModule.querySelector('#applied-filters-pills-desktop');

	// Clear both containers - let responsive CSS control visibility
	if (mobileContainer) {
		mobileContainer.innerHTML = '';
	}
	if (desktopContainer) {
		desktopContainer.innerHTML = '';
	}

	Object.keys(facetValues).forEach(facetName => {
		const facetValuesList = facetValues[facetName];
		if (facetValuesList && Array.isArray(facetValuesList)) {
			facetValuesList.forEach(value => {
				if (value) {
					const pill = searchFacets.createFilterPill(facetName, value);
					if (mobileContainer) {
						// Create separate pill for mobile to ensure event handlers work
						const mobilePill = searchFacets.createFilterPill(facetName, value);
						mobileContainer.appendChild(mobilePill);
					}
					if (desktopContainer) desktopContainer.appendChild(pill);
				}
			});
		}
	});

	const hasAppliedFilters = Object.keys(facetValues).length > 0;
	const container = searchListingModule.querySelector('.applied-filters-container');
	if (container) {
		if (hasAppliedFilters) {
			container.classList.remove('empty');
		} else {
			container.classList.add('empty');
		}
	}

	if (mobileContainer) {
		mobileContainer.scrollLeft = 0;
	}
	if (desktopContainer) {
		desktopContainer.scrollLeft = 0;
	}

	// Update button states after DOM has rendered
	requestAnimationFrame(() => {
		if (mobileContainer) {
			searchFacets.updatePillsScrollButtons(mobileContainer, 'mobile');
		}
		if (desktopContainer) {
			searchFacets.updatePillsScrollButtons(desktopContainer, 'desktop');
		}
	});
};

searchFacets.createFilterPill = function (facetName, value) {
	const pill = document.createElement('div');
	pill.className = `filter-pill filter-pill-${facetName.toLowerCase().replace(/\s+/g, '-')}`;

	// const checkmark = document.createElement('span');
	const label = document.createElement('span');
	label.className = 'filter-pill-label';

	let displayValue = value;
	try {
		displayValue = decodeURIComponent(displayValue).replace(/\+/g, ' ');
	} catch (e) {
		// If decoding fails, just replace + with spaces
		displayValue = displayValue.replace(/\+/g, ' ');
	}

	// Split category and subcategorites to display as Category: subcategory > subcategory2 > ...
	const normalizedDisplayValue = displayValue.replace(/%3E/gi, '>');
	const parts = normalizedDisplayValue.split('>').map(p => p.trim()).filter(Boolean);
	const hasSubcategories = parts.length > 1;

	const category = document.createElement(hasSubcategories ? 'span' : 'strong');
	const categoryText = (parts[0] || displayValue);
	category.textContent = categoryText + (hasSubcategories ? ': ' : '');
	label.appendChild(category);

	if (hasSubcategories) {
		const subcategoriesContainer = document.createElement('strong');
		const subcategories = parts.slice(1).join(' > ');
		subcategoriesContainer.textContent = subcategories;
		label.appendChild(subcategoriesContainer);	
	}

	const removeBtn = document.createElement('button');
	removeBtn.className = 'filter-pill-remove';
	removeBtn.setAttribute('data-facet-name', facetName);
	removeBtn.setAttribute('data-facet-value', value);
	removeBtn.addEventListener('click', (e) => {
		e.preventDefault();
		e.stopPropagation();
		searchFacets.removeFilterPill(facetName, value);
	});

	// pill.appendChild(checkmark);
	pill.appendChild(label);
	pill.appendChild(removeBtn);

	return pill;
};

searchFacets.removeFilterPill = function (facetName, value) {
	const checkboxes = document.querySelectorAll(`[data-query-name="${facetName}"]`);

	let foundCheckbox = null;

	checkboxes.forEach(checkbox => {
		const checkboxName = checkbox.getAttribute('name');
		const urlName = checkbox.getAttribute('data-url-name');
		const valueToCheck = urlName || checkboxName;

		if (valueToCheck === value) {
			checkbox.checked = false;
			foundCheckbox = checkbox;
		}
	});

	if (foundCheckbox) {
		// Use the checkbox's actual ID and query name for proper handling
		const checkboxId = foundCheckbox.getAttribute('id');
		const queryName = foundCheckbox.getAttribute('data-query-name');
		searchFacets.handleFacetChange(false, checkboxId, queryName, false);
	}
};



/**
 * Check if the facet being deselected is the last one
 * @param {Object} facetValues - Current facet values from DOM
 * @param {string} identifierName - Name of the facet being deselected
 * @returns {boolean} - True if this is the last facet being deselected
 */
searchFacets.isLastFacetBeingDeselected = function(facetValues, identifierName) {
	// Count total selected facets
	let totalSelectedFacets = 0;
	
	// Count facets from facetValues (excluding the one being deselected)
	Object.keys(facetValues).forEach(key => {
		if (key !== identifierName && facetValues[key]) {
			// Count comma-separated values in each facet
			const values = facetValues[key].split(',');
			totalSelectedFacets += values.length;
		}
	});
	
	// Also check category facets
	const facetCategories = searchFacets.getFacetCategories();
	const activeCategoryLink = facetCategories.find(
		(categoryLink) => categoryLink.classList.contains(constants.ACTIVE_CATEGORY_CLASS)
	);
	
	if (activeCategoryLink) {
		totalSelectedFacets += 1;
	}
	
	// If no facets are selected after this deselection, redirect to /products
	return totalSelectedFacets === 0;
};

/**
 * Check if the v_page feature flag is enabled
 * @returns {boolean} - True if the feature flag is enabled
 */
searchFacets.isVPageFeatureFlagEnabled = function() {
	if (searchFacets._featureFlagCache !== null) {
		return searchFacets._featureFlagCache;
	}

	// Try to get the flag from search-filters-module first, then fallback to search-facets-module
	const $filtersModule = rp$('.search-filters-module');
	const $facetsModule = searchFacets.getFacetsModule();

	let vPageFlag = $filtersModule.data('use-search-based-v-page');
	if (vPageFlag === undefined || vPageFlag === null) {
		vPageFlag = $facetsModule.data('use-search-based-v-page');
	}

	// Check if the feature flag is enabled (true, 'true', 1, or '1')
	const isEnabled = vPageFlag === true || vPageFlag === 'true' || vPageFlag === 1 || vPageFlag === '1';

	searchFacets._featureFlagCache = isEnabled;

	return isEnabled;
};

/**
 * Redirect to the products page (base URL without facet parameters)
 */
searchFacets.redirectToProductsPage = function() {
	// Get current URL and remove facet parameters
	const currentUrl = new URL(window.location.href);
	const basePath = currentUrl.pathname;
	
	// Remove facet-related query parameters
	const facetParams = ['autocareCategories', 'category', 'page'];
	facetParams.forEach(param => {
		currentUrl.searchParams.delete(param);
	});
	
	// Build the products URL
	const productsUrl = basePath.replace(/\/products.*$/, '/products');
	
	// Redirect to products page
	window.location.href = productsUrl;
};

searchFacets.saveExpandedState = function(facetQueryName, isExpanded) {
	try {
		const expandedStates = JSON.parse(sessionStorage.getItem('facetExpandedStates') || '{}');
		expandedStates[facetQueryName] = isExpanded;
		sessionStorage.setItem('facetExpandedStates', JSON.stringify(expandedStates));
	} catch (e) {
		// Silently handle storage errors
	}
};

searchFacets.getExpandedStates = function() {
	try {
		return JSON.parse(sessionStorage.getItem('facetExpandedStates') || '{}');
	} catch (e) {
		return {};
	}
};

searchFacets.restoreExpandedStates = function() {
	const expandedStates = searchFacets.getExpandedStates();

	Object.keys(expandedStates).forEach((facetQueryName) => {
		const isExpanded = expandedStates[facetQueryName];

		if (isExpanded) {
			document.querySelectorAll('.hidden-filter-' + facetQueryName).forEach(function(el) {
				el.removeAttribute('hidden');
			});

			document.querySelectorAll(`#see-less-mobile-${facetQueryName}, #see-less-desktop-${facetQueryName}`).forEach(function(el) {
				el.removeAttribute('hidden');
				const parentLi = el.closest('li');
				if (parentLi) {
					parentLi.removeAttribute('hidden');
				}
			});
			document.querySelectorAll(`#see-more-mobile-${facetQueryName}, #see-more-desktop-${facetQueryName}`).forEach(function(el) {
				el.setAttribute('hidden', true);
				const parentLi = el.closest('li');
				if (parentLi) {
					parentLi.setAttribute('hidden', true);
				}
			});
		}
	});
};

searchFacets.saveExpandedState = function(facetQueryName, isExpanded) {
	try {
		const expandedStates = JSON.parse(sessionStorage.getItem('facetExpandedStates') || '{}');
		expandedStates[facetQueryName] = isExpanded;
		sessionStorage.setItem('facetExpandedStates', JSON.stringify(expandedStates));
	} catch (e) {
		// Silently handle storage errors
	}
};

searchFacets.getExpandedStates = function() {
	try {
		return JSON.parse(sessionStorage.getItem('facetExpandedStates') || '{}');
	} catch (e) {
		return {};
	}
};

searchFacets.restoreExpandedStates = function() {
	const expandedStates = searchFacets.getExpandedStates();

	Object.keys(expandedStates).forEach((facetQueryName) => {
		const isExpanded = expandedStates[facetQueryName];

		if (isExpanded) {
			document.querySelectorAll('.hidden-filter-' + facetQueryName).forEach(function(el) {
				el.removeAttribute('hidden');
			});

			document.querySelectorAll(`#see-less-mobile-${facetQueryName}, #see-less-desktop-${facetQueryName}`).forEach(function(el) {
				el.removeAttribute('hidden');
				const parentLi = el.closest('li');
				if (parentLi) {
					parentLi.removeAttribute('hidden');
				}
			});
			document.querySelectorAll(`#see-more-mobile-${facetQueryName}, #see-more-desktop-${facetQueryName}`).forEach(function(el) {
				el.setAttribute('hidden', true);
				const parentLi = el.closest('li');
				if (parentLi) {
					parentLi.setAttribute('hidden', true);
				}
			});
		}
	});
};

module.exports = searchFacets;
